module.exports = __webpack_public_path__ + "static/media/recyclewback.959268d1.svg";